import { render } from "./SalesWidget.vue?vue&type=template&id=ca8a6674"
import script from "./SalesWidget.vue?vue&type=script&lang=js"
export * from "./SalesWidget.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__